"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objFromKeys = void 0;
const objFromKeys = (fn, keys) => keys.reduce((prev, next) => Object.assign(prev, { [next]: fn(next) }), {});
exports.objFromKeys = objFromKeys;
